import React from 'react'
import { Input } from '@chakra-ui/react'

const InputText = ({ inputref, ...rest }) => {
	return <Input {...inputref} {...rest} />
}
export default InputText
